import "slick-carousel";

const $window = $(window);

function initiallizeSlider($slider) {
  if ($window.width() <= 767) {
    if (!$slider.find(".slick-initialized").length) {
      $slider.find(".js-slides").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: false,
        autoplay: false,
      });
    }
  } else {
    if ($slider.find(".slick-initialized").length) {
      $slider.find(".js-slides").slick("unslick");
    }
  }
}

const $sliderTier = $(".js-slider-tiers");

if ($window.width() <= 767) {
  $sliderTier.each(function () {
    const $this = $(this);

    if (!$this.find(".slick-initialized").length) {
      $this.find(".js-slides").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: false,
        autoplay: false,
      });
    }

    $window.on("resize", function () {
      initiallizeSlider($this);
    });
  });
}
